import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

// Tracks a page view to /api/analytics/track on every route change.
// - Skips /admin pages
// - De-duplicates the same path within a 30s window per browser session
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;

    const key = `_at:${path}`;
    const now = Date.now();
    try {
      const last = parseInt(sessionStorage.getItem(key) || "0", 10);
      if (last && now - last < 30000) return;
      sessionStorage.setItem(key, String(now));
    } catch (err) {
      // sessionStorage can be blocked in private browsing / iframes; safe to ignore
      console.warn("Analytics storage unavailable:", err?.message || err);
    }

    api
      .post("/analytics/track", {
        path,
        referrer: document.referrer || null,
      })
      .catch(() => {
        /* analytics should never break the page */
      });
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
